import React, { memo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import EditPhoto from './../../../components/profile/popups/editPhotoPopup'

import { PhotoType } from '../../../store/commonTypes'
import { photoDelete } from '../../../store/member/memberSlice'
import s from './materialPreview.module.sass'
import { isUserPro } from '../../../utils/isUserPro'
import { RootState } from '../../../store/rootReducer'
import useProtectImages from '../../../hooks/useProtectImages'

interface Props {
    photo: PhotoType
    openPhoto: (photo: PhotoType) => void
    isPro?: boolean
    isAgeVerified?: boolean
}

const AlbumItem = ({ photo, openPhoto, isAgeVerified = false, isPro = false }: Props) => {
    useProtectImages(null)
    const location = useLocation()
    const dispatch = useDispatch()
    const user = useSelector((state: RootState) => state.member.user)
    const self = location.pathname.includes('/membre')

    const [isPhotoEditing, setISPhotoEditing] = useState(false)
    return (
        <>
            <div className={s['previewItem']} onClick={() => isAgeVerified && openPhoto(photo)}>
                <img
                    src={photo.thumbnail_url}
                    alt={photo.alt ? photo.alt : ''}
                    className={`${
                        (!user || !isUserPro(user.member_type)) &&
                        photo.type === 'pro' &&
                        !(user && user.id == photo.user.id)
                            ? `${s['onlyForPro']} 'onlyForPro'`
                            : ''
                    }`}
                />

                {self && (
                    <div
                        className={s['edit']}
                        onClick={(event) => {
                            event.stopPropagation()
                            setISPhotoEditing(true)
                        }}
                    />
                )}
            </div>
            {isPhotoEditing && (
                <EditPhoto
                    photo={photo}
                    onClose={() => setISPhotoEditing(false)}
                    onDelete={() => dispatch(photoDelete(photo))}
                />
            )}
        </>
    )
}

export default memo(AlbumItem)
